import { render } from "./AdminUserManagementInfo.vue?vue&type=template&id=f8981ce8&scoped=true"
import script from "./AdminUserManagementInfo.vue?vue&type=script&lang=js"
export * from "./AdminUserManagementInfo.vue?vue&type=script&lang=js"

import "./AdminUserManagementInfo.vue?vue&type=style&index=0&id=f8981ce8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8981ce8"]])

export default __exports__